import type { User } from 'api/data.types'

export const PASSAPORTE_ENTITIES_ID = [
  75064, 75063, 75074, 75075, 75076, 75077, 75107, 75108, 75109, 75149, 75150,
  75151, 75152, 75153, 75154, 75155, 75312, 75313, 75016, 75017, 75018
]

export const isPositivo = (user: User) => {
  return user?.reader?.root?.id === 135277
}

export const isArvore = (user: User) => {
  return user?.reader?.root?.id === 31
}

export const isPositivoPremiumEntity = (user: User) => {
  return (
    user?.reader?.entity?.ancestry?.includes('301762') ||
    user?.reader?.entity?.id === 301762
  )
}

export const isPassaporteUser = (user: User) => {
  return PASSAPORTE_ENTITIES_ID.includes(user?.reader?.entity?.id)
}

export const isNonSchool = (user: User) => {
  return user?.reader?.root?.id === 454982
}

export const isSescRs = (user: User) => {
  return user?.reader?.root?.id === 511817
}

export const isSecretariaSp = (user: User) => {
  return user?.reader?.root?.id === 454982
}

export const isRecife = (user: User) => {
  return user?.reader?.root?.id === 839037
}
